import { Column } from './column';
import { ValueField } from './valuefield';

export class EventData {
    Columns: Column[];
    Rows: Column[];
    Values: ValueField[];
    Filters: Column[];
    Fields: Column[];
}
